// @ts-nocheck
import { checkboxSizes, CheckboxStyle, StyleProps } from "@insite/mobius/Checkbox";
import { IconWrapper } from "@insite/mobius/Icon";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { CheckboxGroupStyleProps } from "@store/MobiusOverrides/CheckboxGroup/CheckboxGroup";
import { checkboxDescriptionSpacingStyles } from "@store/Themes/common/mixins/checkbox";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import CheckboxChecked from "@toolkit/Library/Components/Icons/Checkbox/CheckboxChecked";
import CheckboxIndeterminate from "@toolkit/Library/Components/Icons/Checkbox/CheckboxIndeterminate";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/Checkbox ------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

type CheckboxColor = string | null;
const checkboxStyles = (color?: CheckboxColor, backgroundColor?: CheckboxColor, borderColor?: CheckboxColor) => {
    return css<StyleProps>`
        ${({ theme, _sizeVariant }) => {
            const { borderWidth } = checkboxSizes[_sizeVariant] as any;

            return css`
                border: ${pxToRem(borderWidth)} solid transparent;
                ${cssProp("color", color, x => resolveColor(x, theme))}
                ${cssProp("background-color", backgroundColor, x => resolveColor(x, theme))}
                ${cssProp("border-color", borderColor, x => resolveColor(x, theme))}
            `;
        }}
    `;
};

const checkbox: Styleguide["checkbox"] = {
    defaultProps: {
        iconProps: {
            src: CheckboxChecked,
        },
        indeterminateIconProps: {
            src: CheckboxIndeterminate,
        },
        css: css`
            align-items: flex-start;
            margin-top: 0.1em;

            &:hover {
                span[role="checkbox"]:not([aria-disabled="true"]) {
                    border-color: ${getColor("primary")};
                }
                /* Bunzl custom code */
                label {
                    color: ${getColor("text.linkHover")};
                }
            }

            span[role="checkbox"] {
                padding: ${pxToRem(2)};
                border: ${pxToRem(1)} solid ${getColor("common.borderDark")};
                cursor: pointer;

                &[aria-checked="true"],
                &[aria-checked="mixed"] {
                    border-radius: ${pxToRem(2)};

                    &:not([aria-disabled="true"]) {
                        /* Bunzl custom code */
                        background-color: ${getColor("primary")};
                        border: ${pxToRem(1)} solid ${getColor("primary")};
                        /* Bunzl custom code */

                        color: ${getColor("common.background")};
                    }
                }

                &[aria-disabled="true"] {
                    padding: ${pxToRem(3)};
                    color: ${getColor("common.background")};
                    background-color: ${getColor("common.shadesMedium")};
                    border-color: ${getColor("common.borderLight")};

                    &:hover {
                        border: ${pxToRem(2)} solid ${getColor("common.disabled")};
                        cursor: not-allowed;
                    }

                    & + label {
                        color: ${getColor("text.accent")};

                        &:hover {
                            cursor: not-allowed;
                        }
                    }

                    svg {
                        stroke: ${getColor("common.background")};
                    }
                }

                &:focus {
                    box-shadow: none;
                    outline-color: ${getProp("theme.focus.color")};
                    outline-style: ${getProp("theme.focus.style")};
                    outline-width: ${pxToRem(1)};
                }

                + label {
                    margin: 0 0 0 0.5em;
                    cursor: pointer;
                    &::before {
                        flex-shrink: 0;
                    }
                }
            }
        `,
    },
    groupDefaultProps: {
        css: css<CheckboxGroupStyleProps>`
            ${checkboxDescriptionSpacingStyles()}
            ${({ _sizeVariant = "default" }) => {
                const { itemSpacing } = checkboxSizes[_sizeVariant] as any;

                return css`
                    ${CheckboxStyle} + ${CheckboxStyle} {
                        margin-top: ${pxToRem(itemSpacing)};
                    }
                `;
            }}
        ` as any,
    },
};

export default checkbox;
